<template>
	<v-header title="购物车" :headerLeftStatus="true" />
	<div class="sysMain">
		<div class="sysMainBody">
			<div style="height: 100%;padding-bottom: 30px;">
				<Row style="padding-bottom: 10px;" v-show="suiteList.length>0">
					<Col span="12">
					<Checkbox :indeterminate="view.indeterminate" :model-value="view.checkAll"
						@click.prevent="checkAll">全选
					</Checkbox>
					</Col>
					<Col span="12" style=" text-align: right; ">
					<a href="#" @click.prevent="del" style="color: red;">
						<Icon type="md-trash"></Icon>
						移除
					</a></Col>
				</Row>
				<CheckboxGroup v-model="model.suiteIdList" v-for=" item in suiteList" @on-change="change">
					<Card style=" margin-bottom: 15px;">
						<Row justify="center" align="middle">
							<Col flex="40px">
							<Checkbox :label="item.suiteId"> &ensp;
							</Checkbox>
							</Col>
							<Col flex="auto">
							<Row>
								<Col><b style=" font-size:15px;">{{item.suiteName}}</b></Col>
							</Row>
							<Row>
								<Col style="color: #8C8C8C;">{{item.describe}}</Col>
							</Row>
							<Row justify="center" align="middle">
								<Col span="12">
								<Text type="danger">
									<Numeral :value="item.unitPrice" format="0,0.00">
										<template #prefix>
											<strong>¥</strong>
										</template>
									</Numeral>
								</Text>
								</Col>
								<Col span="12" style="text-align: right;padding-right: 10px;">
								<InputNumber v-model="item.quantity" size="small" style="width: 80px;" controls-outside
									@on-change="changeQuantity" :min="1" :precision="0" />
								</Col>
							</Row>
							</Col>
						</Row>
					</Card>
				</CheckboxGroup>
			</div>
			<div style="position: fixed;left: 0;bottom: 0;height: 40px; background-color: white;width: 100%; ">
				<Row justify="center" align="middle">
					<Col flex="70px" style="padding-left: 10px; "> <Button type="primary" ghost
						@click="this.$router.push('/suite')">继续购买</Button></Col>
					<Col v-show="suiteList.length>0" flex="auto"
						style="font-weight: bold;padding-right: 5px; text-align: right; ">合计<Text type="danger"
						style="padding-right: 10px;">
						<Numeral :value="model.total" format="0,0.00">
							<template #prefix>
								<strong>¥</strong>
							</template>
						</Numeral>
					</Text></Col>
					<Col v-show="suiteList.length>0" flex="70px" style="padding-left: 5px;"> <Button type="primary"
						@click="confirm()">结算</Button>
					</Col>
				</Row>
			</div>
		</div>
		<div style="text-align:center" v-show="suiteList.length===0">
			<Result type="warning" title="" desc="没有相关数据"></Result>
		</div>
	</div>
</template>

<script>
	import header from "@/components/header/index";
	export default {
		name: 'center',
		data() {
			return {
				view: {
					indeterminate: true,
					checkAll: false,
				},
				suiteList: [],
				model: {
					suiteIdList: [],
					total: 0,
				}
			};
		},
		mounted() {
			this.init();
		},
		methods: {
			init() {
				this.suiteList = this.getCart();
			},
			checkAll() {
				if (this.view.indeterminate) this.view.checkAll = false;
				else this.view.checkAll = !this.view.checkAll;
				this.view.indeterminate = false;
				if (this.view.checkAll) this.model.suiteIdList = this.suiteList.map(p => p.suiteId);
				else this.model.suiteIdList = [];
				this.changeTotal();
			},
			change(data) {
				if (data.length === this.suiteList.length) {
					this.view.indeterminate = false;
					this.view.checkAll = true;
				} else if (data.length > 0) {
					this.view.indeterminate = true;
					this.view.checkAll = false;
				} else {
					this.view.indeterminate = false;
					this.view.checkAll = false;
				}
				this.changeTotal();
			},
			changeQuantity() {
				this.setCart(this.suiteList);
				this.changeTotal();
			},
			changeTotal() {
				var that = this;
				var list = this.suiteList.whereEx(function(p) {
					return that.model.suiteIdList.indexOf(p.suiteId) > -1
				});
				this.model.total = list.sumEx(function(p) {
					return p.unitPrice * p.quantity
				});
			},
			del() {
				var that = this;
				this.suiteList.removeAllByFnEx(function(p) {
					return that.model.suiteIdList.indexOf(p.suiteId) > -1
				});
				this.changeQuantity();
			},
			confirm() {
				if (this.model.suiteIdList.length == 0) {
					this.$Message.error('请选择!');
					return false;
				}

				this.$router.push({
					path: '/confirm',
					query: {
						suiteIdList: this.model.suiteIdList
					}
				})
			}

		},
		components: {
			"v-header": header
		}
	}
</script>
